import React from 'react'
import { Login as LoginController } from '../../components/Login'

export const Login = (props) => {
  return (
    <>
      <LoginController {...props} />
    </>
  )
}
